import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { setCurrentPoiID } from "@/features/cartography/cartographySlice";
import { setConfigItem } from "@/features/config/configSlice";

import type { SitumFlightInformation } from "./types";

type SelectedFlightId = SitumFlightInformation["id"];

type FlightInformationState = {
  flights: SitumFlightInformation[];
  refreshedAt: number | null;
  selectedFlightId: SelectedFlightId | null;
};

const initialState: FlightInformationState = {
  flights: [],
  refreshedAt: null,
  selectedFlightId: null,
};

const flightInformationSlice = createSlice({
  extraReducers: (builder) => {
    // Clear selected flight when a POI is selected — ensures mutual exclusivity.
    builder.addCase(setCurrentPoiID, (state) => {
      state.selectedFlightId = null;
    });
    // Remove all flight information data when this feature is disabled
    builder.addCase(setConfigItem, (state, action) => {
      if (
        action.payload.key === "flight_information.enabled" &&
        !action.payload.value
      ) {
        state.flights = [];
        state.refreshedAt = null;
        state.selectedFlightId = null;
      }
    });
  },
  initialState,
  name: "flightInformation",
  reducers: {
    setFlightInformation(
      state,
      action: PayloadAction<{
        flights: SitumFlightInformation[];
        refreshedAt: number;
      }>,
    ) {
      state.flights = action.payload.flights;
      state.refreshedAt = action.payload.refreshedAt;
    },
    setSelectedFlight(state, action: PayloadAction<SelectedFlightId>) {
      state.selectedFlightId = action.payload;
    },
    unsetSelectedFlight(state) {
      state.selectedFlightId = null;
    },
  },
});

export const { setFlightInformation, setSelectedFlight, unsetSelectedFlight } =
  flightInformationSlice.actions;

export default flightInformationSlice.reducer;
